import { createStore, Store as ReduxStore } from 'redux';
import { Reducer } from './reducers';
import { State, Actions } from './type';

const Store: ReduxStore<State, Actions> = createStore(Reducer);

export default Store;